import { make } from 'vuex-pathify'
import store from '../index'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'
import { formatDate } from '@/util/formatters'
import axios from 'axios'

const state = {
  service: {
    inventories: [],
  },

  services: {
    data: [],
    count: 0,
    limit: 50,
  },

  serviceStats: {
    data: {},
    loading: false,
    dialog: false,
  },

  filter: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ['name'],
    sortDesc: [false],
  },

  dialog: false,
  type: 'add',
  loading: false,
  campagPontoPriceRanges: [],
}

const mutations = make.mutations(state)

const actions = {
  getCampagPontoPriceRanges: ({ state }) => axios
    .get(`${process.env.VUE_APP_API_URL}/integrations/campag-ponto/price-ranges`)
    .then(({ data }) => {
      state.campagPontoPriceRanges = data.ranges
      return data.ranges
    })
    .catch(showError),

  saveCampagPontoPriceRanges: ({ state }, ranges) => axios
    .put(`${process.env.VUE_APP_API_URL}/integrations/campag-ponto/price-ranges`, { ranges })
    .then(({ data }) => {
      state.campagPontoPriceRanges = data.ranges
      return data.ranges
    })
    .catch(error => {
      showError(error)
      throw error
    }),
  add: ({ state }) => {
    state.service = {
      active: true,
      nbs: null,
      municipalTaxCode: null,
      nfseIssWithholding: null,
      companyId: store.get('authStore@currentCompany').id,
    }
    state.type = 'add'
    state.dialog = true

    store.dispatch('serviceStore/loadCombos')
  },

  edit: ({ state }, id) => {
    state.loading = true
    store.dispatch('serviceStore/getById', id)
      .then(res => {
        state.service = res.data

        state.type = 'edit'
        state.dialog = true

        store.dispatch('serviceStore/loadCombos')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  view: ({ state }, id) => {
    state.loading = true
    store.dispatch('serviceStore/getById', id)
      .then(res => {
        state.service = res.data

        state.type = 'view'
        state.dialog = true

        store.dispatch('serviceStore/loadCombos')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  loadCombos: async () => {
    store.dispatch('providerStore/get', {
      page: 1,
      itemsPerPage: 10000,
      sortBy: ['name'],
      sortDesc: [false],
    })

    store.dispatch('categoryStore/get', {
      page: 1,
      itemsPerPage: 10000,
      type: 3,
      sortBy: ['name'],
      sortDesc: [false],
    })

    store.dispatch('companyStore/get', {
      page: 1,
      itemsPerPage: 10000,
      sortBy: ['name'],
      sortDesc: [false],
    })
  },

  showServiceStats: ({ state }, id) => {
    state.serviceStats.loading = true
    return axios
      .get(`${process.env.VUE_APP_API_URL}/service-stats/${id}`)
      .then(res => {
        state.serviceStats.data = res.data
        state.serviceStats.dialog = true

        // format data
        state.serviceStats.data.lastRequest = res.data.lastRequest
          ? formatDate(new Date(res.data.lastRequest).toISOString().substr(0, 10))
          : null
      })
      .catch(showError)
      .finally(() => (state.serviceStats.loading = false))
  },

  save: ({ state }, service) => {
    const id = service.id
    const method = id ? 'put' : 'post'

    state.loading = true
    return axios[method](`${process.env.VUE_APP_API_URL}/service/${id || ''}`, service)
      .then((res) => {
        state.dialog = false
        store.dispatch('serviceStore/get')
        showSuccess('Serviço salvo com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  get: async ({ state }, filter = state.filter) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/service?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.services = res.data
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getById: (context, id) => axios.get(`${process.env.VUE_APP_API_URL}/service/${id}`).catch(showError),

  getNbs: (context, filter = {}) => {
    return axios.get(`${process.env.VUE_APP_API_URL}/nbs?${getQueryFromFilter(filter)}`)
      .then(res => res.data)
      .catch(showError)
  },

  getByServiceCode: async ({ state }, filter = state.filter) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/service?${getQueryFromFilter(filter)}`)
      .then(res => res.data)
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getCfops: ({ state }, filter = {}) => {
    state.cfops.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/cfops?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.cfops = res.data
      })
      .catch(showError)
      .finally(() => (state.cfops.loading = false))
  },

  getNcms: ({ state }, filter = {}) => {
    state.ncms.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/ncms?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.ncms = res.data
      })
      .catch(showError)
      .finally(() => (state.ncms.loading = false))
  },

  reloadPrices: (context) => {
    state.loading = true
    return axios.post(`${process.env.VUE_APP_API_URL}/reload-prices`)
      .then(_ => {
        store.dispatch('serviceStore/get')
        showSuccess('Preços dos serviços recalculados com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  remove: ({ state }, id) => {
    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/service/${id}`)
      .then(_ => {
        store.dispatch('serviceStore/get')
        showSuccess('Serviço excluído com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
